import styled from 'styled-components';
import { ChevronDownIcon } from '@root/styles/icons';

export const ChevronDownStyled = styled(ChevronDownIcon)`
  width: 24px;
  position: absolute;
  top: 10px;
  right: 7px;
  pointer-events: none;
`;
